export const BRAND = "Storm Damage Pros";
export const REP_NAME = "JD Dean";
export const PHONE = "470-790-7744";
export const PHONE_TEL = "4707907744";
export const EMAIL = "jd.dean@bestchoiceroofing.com";

export const COUNTIES = [
  "Douglas", "DeKalb", "Carroll", "Fayette", "Coweta",
  "Spalding", "Henry", "Clayton", "Fulton", "Troup", "Newton",
  "Jasper", "Butts", "Lamar", "Rockdale",
  // Expansion — Dec 2025
  "Pike", "Upson", "Meriwether", "Monroe",
  "Heard",
];

export const GOOGLE_REVIEW_URL = "https://www.google.com/search?sca_esv=26d9fb2b0a4b5cca&rlz=1C5MACD_en&sxsrf=ANbL-n5hzNJhlho-Nyoe630Y2CgxKn_rlA:1780860918090&si=AL3DRZHrmvnFAVQPOO2Bzhf8AX9KZZ6raUI_dT7DG_z0kV2_x1LgOXhyVDZC16YAGK3nCJeFf1bkXFaUS7hDGR8G5x5-WykMbRdIHVU9y1crvEB_5YdAMTk4VWMXO6PpJCspuN_ifNvJphMA5WevfpWioV1urj3jyg%3D%3D&q=Best+Choice+Roofing+Reviews&sa=X&ved=2ahUKEwiz-Krz7_WUAxXH6ckDHYq3N7wQ0bkNegQIOBAH&biw=1680&bih=857&dpr=2";

export const SHINGLE_LINES = [
  {
    name: "GAF Timberline Natural Shadow",
    tier: "Good",
    tag: "Classic Beauty",
    blurb: "Timeless dimensional wood-shake look with 110 MPH wind rating and lifetime warranty.",
    image: "/shingles/natural-shadow.png",
    colors: ["Charcoal", "Barkwood", "Pewter Gray", "Weathered Wood"],
    upgrade: { label: "Standard", price: "Included with approved claim", free: true },
    warranty: { labor: "5-Year Labor Warranty", material: "Limited Lifetime Material Warranty" },
  },
  {
    name: "GAF Timberline HDZ",
    tier: "Better",
    tag: "High Definition",
    blurb: "America's #1-selling shingle. LayerLock™ tech, unlimited wind class 3, 20+ color blends.",
    image: "/shingles/hdz.png",
    colors: ["Pewter Gray", "Charcoal", "Hunter Green", "Patriot Red", "Biscayne Blue", "Copper Canyon"],
    upgrade: { label: "Upgrade", price: "$60 / Sq." },
    warranty: { labor: "10-Year Labor Warranty", material: "Limited Lifetime Material Warranty" },
  },
  {
    name: "GAF Timberline UHDZ",
    tier: "Best",
    tag: "Ultra High Definition",
    blurb: "Highest-performing shingle. Thicker shake-like depth, Class 4 impact, lifetime warranty.",
    image: "/shingles/uhdz.png",
    colors: ["Barkwood", "Charcoal", "Shakewood", "Slate", "Weathered Wood", "Williamsburg Slate"],
    upgrade: { label: "Upgrade", price: "$120 / Sq." },
    warranty: { labor: "30-Year Labor Warranty", material: "Limited Lifetime Material Warranty" },
  },
];

export const TIME_WINDOWS = [
  "9AM-11AM",
  "11AM-1PM",
  "1PM-3PM",
  "3PM-5PM",
  "5PM-7PM",
];

export const TRUST_BADGES = [
  { label: "Owens Platinum Preferred Contractor" },
  { label: "GAF National Circle Member" },
  { label: "17+ Years Roofing Experience" },
  { label: "Insurance Claim Specialist" },
];
